import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import ProdutoService from "../../../services/ProdutoService";
import CargoService from "../../../services/CargoService";
import moment from "moment/moment";
import {getByAtribute} from "../../../utils/formatar";

export default class ContratacoesFiltroStore {
    @observable filtros;
    @observable momentDataInicioFiltro;
    @observable momentDataFimFiltro;
    @observable dataInicioFiltroValidacao;
    @observable dataFimFiltroValidacao;
    @observable cargosFiltrados;
    @observable cargoSelecionado;
    @observable produtoSelecionado;
    @observable cargos;

    constructor() {
        this.cargoService = new CargoService();
        this.produtoService = new ProdutoService();
        this.resetFiltros();
    }

    resetFiltros = () => {
        this.filtros = {
            nomeSolicitante: null,
            idCargo: null,
            motivo: null,
            idProduto: null,
            idLocal: null,
            dataInicio: null,
            dataFim: null,
            status: null,
            numeroSolicitacao: null
        }
    };

    carregarListaTodosCargos = () => {
        this.cargoService.listFromBase().then(response => {
            this.cargos = response.data;
        }).catch(error => {
            console.log(error);
        })
    };

    carregarDadosDaUrl = (params) =>{
        extendObservable(this.filtros, params);
        this.carregarDadosCargoUrl(params),
        this.carregarDadosProdutoUrl(params),
        this.carregarDadosDataInicioUrl(params),
        this.carregarDadosDataFimUrl(params),
        this.carregarTabela();
    };

    carregarTabela = () => {
        console.log("implemente o método carregarTabela")
    };

    carregarDadosCargoUrl = (params) => {
        if(params && params.idCargo) {
            this.filtros.idCargo = params.idCargo;
        }
    };

    carregarDadosProdutoUrl = (params) => {
        if(params && params.idProduto) {
            this.produtoService.findById(params.idProduto).then(response => {
                if(response.data) {
                    const codigo = response.data.codigo ? " ("+response.data.codigo+")" : "";
                    response.data.labelValue = response.data.nome + codigo;
                    this.produtoSelecionado = response.data;
                }
            }).catch(error => {
                this.filtros.idProduto = null;
                console.log("Erro ao carregar projeto/centro de resultado/finalidade", error)
            })
        }
    };

    carregarDadosDataInicioUrl = (params) => {
        if(params && params.dataInicio) {
            this.momentDataInicioFiltro = moment(params.dataInicio, "DD-MM-YYYY");
        }
    };

    carregarDadosDataFimUrl = (params) => {
        if(params && params.dataFim) {
            this.momentDataFimFiltro = moment(params.dataFim, "DD-MM-YYYY");
        }
    };

    setCargo = (value) => {
        this.filtros.idCargo = value;
    };

    setProduto = (value, options) => {
        this.filtros.idProduto = value;
        this.produtoSelecionado = options[0];
    };

    setMotivo = (value) => {
        this.filtros.motivo = value;
    };

    setNomeSolicitante = (value) => {
        this.filtros.nomeSolicitante = value;
    };

    setStatus = (value) => {
        this.filtros.status = value;
    };

    setNumeroSolicitacao = (value) => {
        this.filtros.numeroSolicitacao = value;
    };

    setMomentDataInicioFiltro = (value) => {
        if(value) {
            let startDate = value;
            startDate = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            let endDate = this.momentDataFimFiltro;
            if (endDate != null && endDate.length !== 0 && startDate != null && startDate.length !== 0 && startDate.isAfter(endDate)) {
                endDate = null
            }
            this.momentDataInicioFiltro = startDate;
            if (startDate != null && startDate.length !== 0) {
                this.filtros.dataInicio = startDate.format('DD-MM-YYYY');
            }
            else {
                this.filtros.dataInicio = null;
            }
            this.momentDataFimFiltro = endDate;
            if (endDate != null && endDate.length !== 0) {
                this.filtros.dataFim = endDate.format('DD-MM-YYYY');
            }
            else {
                this.filtros.dataFim = null;
            }
            this.dataInicioValidacao =  moment(value).format('DD/MM/YYYY');
        } else {
            this.filtros.dataInicio = null;
            this.momentDataInicioFiltro = null;
            this.dataInicioFiltroValidacao = null;
        }
    };

    setDataInicioCheck = (value) => {
        this.dataInicioFiltroValidacao = value;
        if(!value) {
            this.filtros.dataInicio = "";
            this.dataInicioFiltroValidacao = null;
        }
    };

    setMomentDataFimFiltro = (value) => {
        if(value) {
            let startDate = this.momentDataInicioFiltro;
            let endDate = value;
            endDate = moment(endDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            if (endDate != null && endDate.length !== 0 && startDate != null && startDate.length !== 0 && startDate.isAfter(endDate)) {
                startDate = null;
            }
            this.momentDataInicioFiltro = startDate;
            if (startDate != null && startDate.length !== 0) {
                this.filtros.dataInicio = startDate.format('DD-MM-YYYY');
            }
            else {
                this.filtros.dataInicio = null;
            }
            this.momentDataFimFiltro = endDate;
            if (endDate != null && endDate.length !== 0) {
                this.filtros.dataFim = endDate.format('DD-MM-YYYY');
            }
            else {
                this.filtros.dataFim = null;
            }
            this.dataFimFiltroValidacao = moment(value).format('DD/MM/YYYY');
        } else {
            this.filtros.dataFim = null;
            this.momentDataFimFiltro = null;
            this.dataFimFiltroValidacao = null;
        }
    };

    setDataFimCheck = (value) =>{
        this.dataFimFiltroValidacao = value;
        if(!value) {
            this.filtros.dataFim = "";
            this.dataFimFiltroValidacao = null;
        }
    };

    filtrarProdutos = (input, callback)=> {
        let result = [];
        if(input && input.length > 1) {
            this.produtoService.listByPrefixoDescricaoBanco(input).then(response => {
                callback(null, {
                    options: response.data.map(produto => {
                        const codigo = produto.codigo ? " ("+produto.codigo+")" : "";
                        produto.labelValue = produto.nome + codigo;
                        return produto;
                    }),
                    complete: false
                });
            }).catch(error => {
                callback(null, {options: result,complete: false});
                console.log(error)
            });
        } else {
            callback(null, {options: result,complete: false});
        }
    };
}